import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
// language list
import { NgSelectConfig } from '@ng-select/ng-select';
import { TranslateService } from '@ngx-translate/core';
import Notiflix from 'notiflix';
import { AuthService } from './modules/core/services/auth.service';
import { SocketService } from './modules/core/services/socket.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {

  constructor(
    private config: NgSelectConfig,
    private auth: AuthService,
    private translate: TranslateService,
    private socketService: SocketService
  ) {
    this.config.notFoundText = 'Kayıt bulunamadı.';
  }

  ngOnInit() {
    const lang = localStorage.getItem('lang') || 'en';
    this.translate.setDefaultLang(lang);
    Notiflix.Loading.init({
      zindex: 10011
    });
    Notiflix.Notify.init({
      zindex: 10011
    });
    Notiflix.Confirm.init({
      zindex: 10011
    });
    // this.socketService.connect();
  }

}
